import { render, staticRenderFns } from "./RegisterByTG.vue?vue&type=template&id=6c56eb30&scoped=true"
import script from "./RegisterByTG.vue?vue&type=script&lang=js"
export * from "./RegisterByTG.vue?vue&type=script&lang=js"
import style0 from "./RegisterByTG.vue?vue&type=style&index=0&id=6c56eb30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c56eb30",
  null
  
)

export default component.exports